import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { firstValueFrom } from "rxjs";

export enum SnapshotType {
  NEW,
  UPDATE
}

export class PropertyChange {
  property: string;
  left: string;
  right: string;
}

//CdoSnapshot
/* java properties:
*     private OffsetDateTime commitDate;
    private String entityType;
    private SnapshotType snapshotType;
    private long majorId;
    private int minorId;
    private GlobalId globalId;
    private List<String> changed;
    private Map<String, Object> stateProperties = new HashMap<>();
*  */
export class CdoSnapshot {
  commitDate: Date;
  entityType: string;
  snapshotType: SnapshotType;
  majorId: number;
  minorId: number;
  globalId: string;
  changed: string[];
  stateProperties: any;
}

export class AuditData {
  author: string;
  commitDate: Date;
  majorId: number;
  minorId: number;
  snapshotType: SnapshotType;
  entityType: string;
  stateProperties: PropertyChange[];
  changed: string[];
}

export class AuditResult {
  content: AuditData[];
  empty: boolean;
  first: boolean;
  last: boolean;
  numberOfElements: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

@Injectable({
  providedIn: "root"
})
export class AuditService {
  private clientConfigService = inject(ClientConfigService);
  private http = inject(HttpClient);

  public async queryAudit(id, type, page, size): Promise<CdoSnapshot[]> {
    const config = await this.clientConfigService.config;
    let result: any = await firstValueFrom(
      this.http.get(
        `${config.serviceUrl}/api/v1/audit/${type}/${id}?page=${page}&size=${size}`,
        { withCredentials: true }
      )
    );
    console.log(result);
    return result.content as CdoSnapshot[];
  }

  public async querySnapshot(
    id,
    type,
    commitId,
    page,
    size
  ): Promise<CdoSnapshot> {
    const config = await this.clientConfigService.config;
    let result: any = await firstValueFrom(
      this.http.get(
        `${config.serviceUrl}/api/v1/audit/${type}/${id}/snapshot/${commitId}?page=${page}&size=${size}`,
        { withCredentials: true }
      )
    );
    console.log(result);
    return result as CdoSnapshot;
  }
}
